export interface WorkTypeColor {
  name: string;
  solid: string;
  light: string;
  text: string;
}

export const WORK_TYPE_COLORS: WorkTypeColor[] = [
  { name: 'Crimson',  solid: '#B83245', light: '#FBEAED', text: '#7A1F2D' },
  { name: 'Clay',     solid: '#B54A2A', light: '#FBEEE9', text: '#7A2A14' },
  { name: 'Amber',    solid: '#B87820', light: '#FBF3E0', text: '#7A4E10' },
  { name: 'Straw',    solid: '#9A8A18', light: '#F8F5D8', text: '#685A10' },
  { name: 'Fern',     solid: '#6A8C20', light: '#EEF4DC', text: '#3E5210' },
  { name: 'Sage',     solid: '#2A7A55', light: '#E2F4EC', text: '#0E4830' },
  { name: 'Teal',     solid: '#107878', light: '#E0F2F2', text: '#064848' },
  { name: 'Cyan',     solid: '#1478A0', light: '#E0EEF8', text: '#083858' },
  { name: 'Denim',    solid: '#2452A8', light: '#E4EDFC', text: '#122868' },
  { name: 'Navy',     solid: '#2A3A92', light: '#E8ECFC', text: '#16227A' },
  { name: 'Indigo',   solid: '#3C38B0', light: '#EAEAFC', text: '#202072' },
  { name: 'Violet',   solid: '#6030A8', light: '#EEE8FC', text: '#381868' },
  { name: 'Plum',     solid: '#8028A0', light: '#F4E8FC', text: '#481860' },
  { name: 'Mulberry', solid: '#A02888', light: '#FAE8F4', text: '#601850' },
  { name: 'Berry',    solid: '#A83060', light: '#FAE8EF', text: '#6A2040' },
  { name: 'Slate',    solid: '#4A6078', light: '#EAEFF4', text: '#2A3848' },
];
